import React, { useEffect, useCallback } from 'react';

export const useClickOutside: <
  T extends HTMLElement | null | undefined,
  S extends HTMLElement | null | undefined
>({
  ref,
  onClickOutside,
  isOpen,
  exclusion,
}: {
  ref: React.MutableRefObject<T>;
  onClickOutside: () => void;
  isOpen: boolean;
  exclusion?: React.MutableRefObject<S>;
}) => void = ({ ref, onClickOutside, isOpen, exclusion }): void => {
  const handleClickOutside = useCallback(
    (e) => {
      if (!ref?.current?.contains(e.target) && exclusion?.current !== e.target) {
        onClickOutside();
      }
    },
    [ref, onClickOutside, exclusion]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, isOpen]);
};

export default useClickOutside;
